import { render } from "./RegularCourseCard.vue?vue&type=template&id=dab67fc6&scoped=true"
import script from "./RegularCourseCard.vue?vue&type=script&lang=js"
export * from "./RegularCourseCard.vue?vue&type=script&lang=js"

import "./RegularCourseCard.vue?vue&type=style&index=0&id=dab67fc6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab67fc6"]])

export default __exports__